import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=4c26d45c&scoped=true"
import script from "./tableItem.vue?vue&type=script&lang=js"
export * from "./tableItem.vue?vue&type=script&lang=js"
import style0 from "./tableItem.vue?vue&type=style&index=0&id=4c26d45c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c26d45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c26d45c')) {
      api.createRecord('4c26d45c', component.options)
    } else {
      api.reload('4c26d45c', component.options)
    }
    module.hot.accept("./tableItem.vue?vue&type=template&id=4c26d45c&scoped=true", function () {
      api.rerender('4c26d45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/product/components/tableItem.vue"
export default component.exports